import EmptyStateImg from '../assets/images/empty_state.svg'

const noPermissionState = ({ message, height, type }) => {
  return (
    <div className='flex flex-col items-center justify-center w-full' style={{ height: height ?? "60vh" }}>
      <img src={EmptyStateImg} className='img img-fluid' alt='' width={300}/>
      {message ? <h5 className='fs-small theme-dark-color mt-16'>{message}</h5> :
        <h6 className='fs-header theme-dark-color mt-16'>{"No Permission Found..!"}</h6>
        } 
    </div>
  )
}
export default noPermissionState;
